import { useState } from 'react'

export function useSidePanel() {
	const [showSidePanel, setShowSidePanel] = useState(true)

	return {
		showSidePanel,
		setShowSidePanel,
	}
}
